import { Button, Flex, Typography } from 'antd'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { IconPickerModal } from 'src/components'
import type { IconPickerValue } from 'src/components'
import { useHasWorkspacePermissions } from 'src/hooks'
import { WorkspacePermissionCode } from 'src/utils/workspacePermissions'

import { appIconFromPickerValue } from '../utils/appIcon'

import { AppIcon } from './AppIcon'

type AppIconFieldProps = {
  /** Instance type behind the placeholder plate shown before anything is picked. */
  appType?: string
  value?: IconPickerValue | null
  onChange?: (value: IconPickerValue | null) => void
}

const PREVIEW_SIZE = 36

export const AppIconField = ({
  appType,
  value,
  onChange
}: AppIconFieldProps) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  const mayUploadPhoto = useHasWorkspacePermissions(
    WorkspacePermissionCode.ATTACHMENTS_UPLOAD
  )

  const hint = mayUploadPhoto
    ? t('workspace.apps.iconField.hint')
    : t('workspace.apps.iconField.hintIconsOnly')

  return (
    <Flex align="center" gap={10}>
      <AppIcon
        type={appType}
        size={PREVIEW_SIZE}
        {...appIconFromPickerValue(value)}
      />

      <Button onClick={() => setOpen(true)}>
        {t('workspace.apps.iconField.pick')}
      </Button>

      {value && (
        <Button type="link" onClick={() => onChange?.(null)}>
          {t('workspace.apps.iconField.reset')}
        </Button>
      )}

      <Typography.Text
        type="secondary"
        ellipsis={{ tooltip: hint }}
        style={{ flex: 1, minWidth: 0, fontSize: 12 }}
      >
        {hint}
      </Typography.Text>

      <IconPickerModal
        open={open}
        value={value}
        photo={mayUploadPhoto ? {} : undefined}
        onSelect={(next) => {
          onChange?.(next)
          setOpen(false)
        }}
        onCancel={() => setOpen(false)}
      />
    </Flex>
  )
}
